import sanitizeHtml from 'sanitize-html';

// 空行で段落を分け、単一の改行はそのまま保持する
export function simpleFormat(text: string): string {
  if (!text || text.trim() === '') {
    return '';
  }

  // CRLFをLFに統一
  const normalizedText = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');

  // 連続する改行（空行）で段落を分割
  const paragraphs = normalizedText.split(/\n{2,}/);

  // 各段落を<p>タグで囲む（段落内の改行はそのまま保持）
  return paragraphs
    .map((paragraph) => {
      const content = paragraph.trim();
      return `<p>${content}</p>`;
    })
    .join('\n\n');
}

// NOTE: aタグをはじめとする軽微な装飾タグの表示を許可する
// FIXME: 本番のデータを確認し、使用していないタグがあれば削除したい。合わせてマニュアルの変更もお願いする必要があるかも
export function simpleFormatAllowedDecorate(text: string): string {
  const formatted = simpleFormat(text);

  return sanitizeHtml(formatted, {
    allowedTags: ['a', 'p', 'strong', 'b', 'br'],
    allowedAttributes: {
      '*': ['href', 'rel', 'target', 'title'],
    },
  });
}
